(function ($, settings) {
  $(document).on('endeca.search.results.loaded', function (event, data) {
    var productData = data.results.products.resultData || {};
    // Set a context so that we're not targeting the entire page a second time
    var $c = $('.esearch_results--mobile');
    var $targetGridItemImage = $('.endeca-product-result .js-product-brief-image');
    var $targetShades = $('.js-product-brief-shades__grid .js-product-brief-shades-item');
    var $bestsellerResults = $('#bestseller-results');

    // Add the product data to the data store
    prodcat.data.updateProducts(productData, false);
    Drupal.behaviors.notifyMeV1.setPreorderFlagForGrid();
    // @TODO: Surely there's a better way to re-init quickshops
    // Initialize the quickshops
    var qs = Drupal.behaviors.quickshop;

    qs.attached = false;
    qs.attach($c, settings);

    // Initialize the prodcat UI stuff
    prodcat.ui.init($c);

    // Now that the product grid JS is in a behavoir, we can just reattach everything with a new context
    if (productData.length !== 0) {
      $bestsellerResults.remove();
      Drupal.attachBehaviors($c, settings);
    }

    if (typeof site.l2Request !== 'undefined') {
      site.l2Request.params = site.l2Request.getParams();
      generic.jsonrpc.fetch(site.l2Request);
    }

    if ($targetShades.hasClass('hidden')) {
      $targetShades.removeClass('hidden');
    }

    $targetGridItemImage.once().load(function (e) {
      Drupal.behaviors.productGrid.equalHeights($c);
    });
  });
})(jQuery, Drupal.settings);
